export const gsFieldClassName = `border py-[2px] pl-1 pr-[7px] rounded-md !ml-[8px]`

export const gsFieldsContainerClassName =
   'flex pb-6px gs-fields-selection-styles'
